import { action, observable, computed, makeObservable } from 'mobx';

import { Graph, DEFAULT_SCHEMA } from '@vromo/api/graph';
import { API } from '@vromo/api/api';

import rootStore from '@vromo/dashboard/src/stores/RootStore';

import { EntityList } from '@vromo/models';
import { Role } from '@vromo/models';
import { User } from '@vromo/models';
import { AccountStatus } from '@vromo/models';
import { LocalStorage } from '@vromo/models';

import { update, deserialize } from 'serializr';
import { GraphTree, LimitedGraphTree, UserAccessPosition } from '@vromo/api';

export default class AuthStore {

    token: string | null = null;
    /** @deprecated now the Graph object contains default and limited graphs, this param has no effect*/
    graphSchema: GraphTree | LimitedGraphTree = DEFAULT_SCHEMA;
    roles = new EntityList(Role);
    user = new User();
    role = new Role();
    status = new AccountStatus();
    loaded = false;

    constructor() {
        makeObservable(this, {
            token: observable,
            graphSchema: observable,
            roles: observable,
            user: observable,
            role: observable,
            status: observable,
            loaded: observable,
            login: action,
            logout: action,
            changeRole: action,
            authenticated: computed,
            graph: computed,
            api: computed,
            isFreemium: computed
        });
    }

    login = (user: User, roles: Role[], token: string, role: Role): void => {
        if (role) {
            this.role = deserialize(Role, role);
        }

        update(this.roles, { items: roles, type: 'load' });
        update(this.user, user);

        this.token = token || "";
        this.loaded = true;
    };

    logout = (): void => {
        this.role = new Role();
        this.user = new User();
        this.token = '';
    };

    changeRole = (id: number): void => {

        this.role = this.roles.find((r: Role) => r.id === id)!;
        rootStore.changeRole()

        LocalStorage.role = id;
    };

    get authenticated(): boolean {
        return this.token !== null;
    }

    get graph(): Graph {
        return new Graph(this.user.apiHost, this.token || "");
    }

    get api(): API {
        return new API(this.user.apiHost);
    }
    /** freemium user = limitied to 14 days trial */
    get isFreemium(): boolean {

        if (!this.role?.position?.id) {
            return true
        }
        return [
            UserAccessPosition.freemiumAdmin,
            UserAccessPosition.freemiumUser
        ].includes(this.role.position.id);
    }
}
